// -------------------------------------------------------------------------------------------------
//    Hot Keys
// -------------------------------------------------------------------------------------------------
// Note that keydown and keyup provide a code indicating which key is pressed,
// while keypress indicates which character was entered. For example, a lowercase "a"
// will be reported as 65 by keydown and keyup, but as 97 by keypress. An uppercase "A"
// is reported as 65 by all events. Because of this distinction, when catching special
// keystrokes such as arrow keys, .keydown() or .keyup() is a better choice.
// keycodes can be found at: http://www.webonweboff.com/tips/js/event_key_codes.aspx
//    or http://unixpapa.com/js/key.html
// Note: FF has different keycodes for plus/minus keys [ref: http://unixpapa.com/js/key.html]

export const keyCodes = {
  enter: 13,
  shift: 16,
  control: 17,
  alt: 18,
  escape: 27,
  spacebar: 32,
  arrowLeft: 37,
  arrowUp: 38,
  arrowRight: 39,
  arrowDown: 40,
  zero: 48,
  one: 49,
  two: 50,
  three: 51,
  four: 52,
  five: 53,
  six: 54,
  seven: 55,
  eight: 56,
  nine: 57,
  num0: 96,
  num1: 97,
  num2: 98,
  num3: 99,
  num4: 100,
  num5: 101,
  num6: 102,
  num7: 103,
  num8: 105,
  num9: 107,

  numLock4: 100,
  numLock5: 105,
  numPlus: 107,
  numMinus: 109,
  CapsLock: 20,
  deleteKey: 46,

  a: 65,
  b: 66,
  c: 67,
  d: 68,
  e: 69,
  f: 70,
  g: 71,
  h: 72,
  i: 73,
  j: 74,
  k: 75,
  l: 76,
  m: 77,
  n: 78,
  o: 79,
  p: 80,
  q: 81,
  r: 82,
  s: 83,
  t: 84,
  u: 85,
  v: 86,
  w: 87,
  x: 88,
  y: 89,
  z: 90,

  F1: 112,
  F2: 113,
  F3: 114,
  F4: 115,
  F5: 116,
  F6: 117,
  F7: 118,
  F8: 119,
  F9: 120,
  F10: 121,
  F11: 122,
  F12: 123,

  minus: 189,
  plus: 187,
  FF_minus: 173,
  FF_plus: 61,
  // TODO Need a different approach adding support for different keyboard
  // Consider this: https://stackoverflow.com/a/12825956
  lang: {
    fr: {
      minus: 54
    }
  }
};



// WEBPACK FOOTER //
// ./src/uScope/js/lib/key-codes.js